export default __webpack_public_path__ + "static/media/mobile10.b126f0a3.jfif";